import React from 'react'
import ReactDOMServer from 'react-dom/server'
import { connect } from 'react-redux'
import Linkify from 'linkify-react'
import moment from 'moment-timezone'
import DateFormatter from '../Classes/DateFormatter'

class Chat extends React.Component {
    decodeHightlight(query, text) {
        if (query === "") return text;
        return text.replace(new RegExp(query + '(?!([^<]+)?>)', 'g'), `<span class="highlighted">${query}</span>`)
    }

    attachmentClicked(event, public_url) {
        const image_pattern = /\.(png|jpg|jpeg|gif)$/i;
        const video_pattern = /\.(mp4|avi|mov|wmv|flv|mkv)$/i;
        if (!image_pattern.test(public_url) && !video_pattern.test(public_url)) return;
        event.preventDefault();
        const src = public_url;
        if (image_pattern.test(public_url)) {
            const img = `
            <div class="d-flex w-100 h-100 attachment-modal">
            <img src="` + src + `" class="attachment"  alt="" />
            <span class="close close-attachment cursor-pointer text-white">x</span>
            </div>
            `;
            jQuery('body').append(img);
        } else {
            const video = `
            <div class="d-flex w-100 h-100 attachment-modal">
            <video class="attachment" controls><source src=${src} type="video/mp4"/></video>
            <span class="close close-attachment cursor-pointer text-white">x</span>
            </div>
            `;
            jQuery('body').append(video);
        }

    }

    render() {

        let chat_red_text;

        const formattedDate = moment.tz(new Date(this.props.chat.created_at), this.props.state.business.call_at_timezone);
        const formattedDateOnly = DateFormatter.formatDateOnly(new Date(this.props.chat.created_at), this.props.state.business.call_at_timezone, this.props.state.app_locale);

        let name = null;
        let is_auto = false;
        if (this.props.chat.sender_id !== this.props.state.feedback_detail.user_id) {
            is_auto = this.props.chat.auto_response || this.props.chat.auto_review;
            if (is_auto) {
                name = "Feedback Auto-response";
            } else {
                name = this.props.chat.sender ? (this.props.chat.sender.display_title ? this.props.chat.sender.title : (this.props.chat.sender.firstname ?? '' + " " + this.props.chat.sender.lastname ?? '')) : "User";
            }
        } else {
            if (this.props.hidename) {
                name = "Hidden";
            } else {
                name = this.props.chat.sender ? (this.props.chat.sender.display_title ? this.props.chat.sender.title : (this.props.chat.sender.firstname ?? '' + " " + this.props.chat.sender.lastname ?? '')) : "User";
            }
        }

        let classes = [];
        if (this.props.chat.sender_id !== this.props.state.feedback_detail.user_id) {
            const msg = 'out';
            classes = ['outgoing_msg', 'outgoing_info', 'outgoing_msg_img', 'outgoing_msg_txt mx-2', 'sent_msg'];
        } else {
            const msg = 'in';
            classes = ['incoming_msg', 'incoming_info', 'incoming_msg_img', 'incoming_msg_txt mx-2', 'received_msg'];
        }

        let initial_span;
        if (classes[0] === "outgoing_msg" || (classes[0] === "incoming_msg" && !this.props.hidename)) {
            if (is_auto) {
                initial_span = <span className="user_initials autoresponse"><i className="fal fa-robot"></i></span>;
            } else {
                initial_span = <span className="user_initials">
                    {this.props.chat.sender && this.props.chat.sender.display_title ? this.props.chat.sender.title.substring(0, 2).toUpperCase() : (this.props.chat.sender.firstname ? (this.props.chat.sender.firstname.substring(0, 1) + (this.props.chat.sender.lastname ? this.props.chat.sender.lastname.substring(0, 1) : "")) : "?")}
                </span>;
            }
        } else {
            initial_span = <span className="user_initials">H</span>;
        }

        if (this.props.red_alerts_list) {
            const keywords = this.props.red_alerts_list;
            if (keywords) {
                chat_red_text = ReactDOMServer.renderToStaticMarkup(<Linkify
                    options={{target: '_blank'}}>{this.props.chat.message}</Linkify>);
                let i;
                for (i = 0; i < keywords.length; i++) {
                    const keyword = keywords[i];
                    if (chat_red_text.toLowerCase().includes(keyword.toLowerCase())) {
                        chat_red_text = chat_red_text.replace(new RegExp(keyword + '(?!([^<]+)?>)', "ig"), '<span class="text-danger font-weight-bold">' + keyword + '</span>');
                    }
                }
            }
        }

        return (
            <div className="chat_widget_body">
                <div className={classes[0]}>
                    <div className={classes[1]}>
                        <div className={classes[2]}>
                            {initial_span}
                        </div>
                        <div className={classes[3]}>
                            {this.props.chat.sender && !is_auto ? this.props.chat.sender.title : "Auto"}
                        </div>
                    </div>
                    <div className={classes[4]}>
                        {chat_red_text &&
                            <p className={"chat_texts " + (is_auto ? 'autoresponse' : '')} dangerouslySetInnerHTML={{
                                __html: this.decodeHightlight(this.props.state.query, chat_red_text)
                            }}></p>
                        }
                        {!chat_red_text && this.props.chat.message?.length > 0 &&
                            <div className={"chat_texts " + (is_auto ? 'autoresponse' : '')}>
                                <div dangerouslySetInnerHTML={{
                                    __html: this.decodeHightlight(this.props.state.query, ReactDOMServer.renderToStaticMarkup(
                                        <Linkify options={{target: '_blank'}}>{this.props.chat.message}</Linkify>))
                                }}></div>
                            </div>
                        }
                        {this.props.chat.attachments && (
                            <div className="chat_attachments">
                                {this.props.chat.attachments.map((att) => {
                                    const fileExtension = att.extension.toLowerCase();
                                    const isImage = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "heic"].includes(fileExtension);
                                    const isVideo = ["mp4", "avi", "mov", "mkv", "webm"].includes(fileExtension);
                                    const isDocument = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "zip"].includes(fileExtension);

                                    return (
                                        <a key={att.file} href={att.url} target="_blank" rel="noopener noreferrer"
                                           onClick={(event) => this.attachmentClicked(event, att.url)}
                                           className="ml-1">

                                            {isImage ? (
                                                <img src={att.url} height="50" width="50" alt="attachment"/>
                                            ) : isVideo ? (
                                                <i className="fas fa-play-circle fa-3x"></i>
                                            ) : isDocument ? (
                                                <i className="fas fa-file-alt fa-3x"></i>
                                                ) : (
                                                <i className="fas fa-file fa-3x"></i>
                                                )}

                                        </a>
                                    );
                                })}
                            </div>
                        )}
                        <span className="time_date">
                            {formattedDate.format('h:mm A')} {formattedDate.format('z')} | {formattedDateOnly} |{" "}
                            {name}
                            {this.props.edited_indicator}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {state: state}
}

export default connect(mapStateToProps)(Chat);
